import React, { useMemo, useState } from "react";
import { colors, fonts, glyphs } from "../../../Styles";
import {  EnhancedWidget, ProgressCircle, ReportShortCut, CheckBox, CheckStyles, Button } from "../..";
import { ButtonTypes } from "../../../Definitions";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { NavigationFunction as RootNavigation, Pages } from "../../../Navigation/Routers/root";
import { useDefaultProgressCircles } from "../../_Components/";

// TODO
import { TestData as ReportData } from "../../../Assets/TestData/autoReports";
import { ReportShortCut_Type } from "../../Reports/reportShortCut ";
import Slider from "../../slider";
import AutoReportModal from "../Modals/autoReportModal";

interface AutoReportWidgetProps {
  header: string;
  systemId: number;
  verticalContent: boolean;
  autoReports: number[];
  progressCircles: number[];
}

/**
 * Feeding
 * @returns A widget widt feeding calendar.
 */
export default function AutoReportWidget({ header, verticalContent, systemId, autoReports, progressCircles }: AutoReportWidgetProps) {
  const { t } = useTranslation();
  const navigator = useNavigate();
  const [addAutoReportModal, setAddAutoReportModal] = useState<boolean>(false)

  const autoReportsToShow = ReportData.filter((r) =>
      r.reportId !== undefined && autoReports.includes(r.reportId)
  );

  const defaultProgressCircles = useDefaultProgressCircles(
    useMemo(() => ({ system: systemId }), [systemId])
  );

  const progressCirclesToShow = defaultProgressCircles.filter((c) =>
    progressCircles.includes(c.progressCircleId)
  );

  const isProgressCircleChecked = (progressCircleId: number) =>
    progressCircles.includes(progressCircleId);

  return (
    <EnhancedWidget
      verticalContent={verticalContent}
      header={header}
      onSave={() => console.log("save")}
      rightContent={ <div style={{ display: "flex", flexDirection: "column", padding: "0px 20px", boxSizing: "border-box" }} >
        <p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, textAlign: "center", boxSizing: "border-box", marginBottom: "10px", marginTop: "20px" }} >
          {t("autoReports", { defaultValue: "Auto Reports" })}
        </p>
        <div style={{ backgroundColor: colors.greySecondary, width: "100%", height: "2px"}} />
        <div style={{
            height: "191px",
            justifyContent: "start",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "10px",
            padding: "10px 10px 10px 0px",
            overflowY: "scroll",
            boxSizing: "border-box",
            scrollbarWidth: "thin",
            scrollbarColor: colors.greySecondary + colors.transparent,
        }}>
          {autoReportsToShow?.map((report, index) => (
            <ReportShortCut
              key={index}
              header={report.name ?? ""}
              amount={0}
              onClick={() => RootNavigation( navigator, Pages.animals, Pages.animals, true, { selected: report.reportId })}
            />
          ))}
        </div>
      </div> }
      leftContent={ <>
        {progressCirclesToShow.length < 3 ? (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 120px)", gridAutoRows: "auto", height: "100%", width: "100%", gap: "30px", alignItems: "center", justifyContent: "center"}} >
            {progressCirclesToShow.map((progressCircle, index) => {
              return (
                <ProgressCircle
                  animation
                  key={progressCircle.progressCircleId}
                  header={progressCircle.header}
                  unit={progressCircle.unit}
                  progressed={progressCircle.progressed}
                  total={progressCircle.total}
                />
              );
            })}
          </div>
        ) : (
          <div style={{ display: "flex", height: "100%", width: "100%", alignItems: "center"}} >
            <Slider
              content={progressCirclesToShow.map((progressCircle, index) => {
                return (
                  <ProgressCircle
                    animation
                    key={progressCircle.progressCircleId}
                    header={progressCircle.header}
                    unit={progressCircle.unit}
                    progressed={progressCircle.progressed}
                    total={progressCircle.total}
                  />
                );
              })}
            />
          </div>
        )}
      </> }
      editMode={{
        editHeader: true,
        editLeftContent: ( <>
          <div style={{
            height: "240px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            boxSizing: "border-box",
            width: "100%",
            overflowY: "scroll",
            scrollbarColor: colors.greyTertiary + colors.transparent,
            scrollbarWidth: "thin",
            padding: "20px",
          }}>
            {defaultProgressCircles.map((progressCircle, index) => (
              <CheckBox
                key={progressCircle.progressCircleId}
                text={progressCircle.header}
                isChecked={isProgressCircleChecked(progressCircle.progressCircleId)}
                checkStyle={CheckStyles.grey}
              />
            ))}
          </div>
        </> ),
        editRightContent: (
          <div style={{ display: "flex", flexDirection: "column", padding: "0px 20px", boxSizing: "border-box" }}>
            <p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, textAlign: "center", boxSizing: "border-box", marginBottom: "10px", marginTop: "20px" }}>
              {t("autoReports", { defaultValue: "Auto Reports" })}
            </p>
            <div style={{ backgroundColor: colors.greySecondary, width: "100%", height: "2px" }}/>
            <div style={{
              height: "191px",
              justifyContent: "start",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: "10px",
              padding: "10px 10px 10px 0px",
              overflowY: "scroll",
              boxSizing: "border-box",
              scrollbarWidth: "thin",
              scrollbarColor: colors.greySecondary + colors.transparent,
            }}>
              {autoReportsToShow?.map((report, index) => (
                <ReportShortCut
                  key={index}
                  header={report.name ?? ""}
                  amount={0}
                  onClick={() => console.log("clicked")} // TODO: delete
                  type={ReportShortCut_Type.delete}
                />
              ))}
              <Button
                content=""
                buttonType={ButtonTypes.textButton}
                startEnhancer={glyphs.Add({})}
                onClick={() => setAddAutoReportModal(true)} // TODO: create
                overrides={{startEnhancerStyles: { margin: "0px" }}}
              />
            </div>

            <AutoReportModal isModalOpen={addAutoReportModal} closeModal={() => setAddAutoReportModal(false)}/>
          </div>
        ),
      }}
    />
  );
}
